/**
 * 배열과 각 배열의 파일 저장 시 사용
 * @param {Object} params - params은 Array로써 vo객체와 fileList 키의 FileVOList 를 가지고 있어야한다.
 * @returns {FormData} - 저장될 FormData key는 voList로 구성되어있다.
 */

export function arrayToFormDataToSave(params) {
  
    const formData = new FormData()

    try
    {
        for(const [i, element] of params.entries()) {
            for (const [key, value] of Object.entries(element)) {
                // fileList 는 이미 formData로 이루어져있어 따로 작업
                if(value != null)
                {
                    if(key != 'fileList' && key != 'fileList2') {
                        formData.append(`voList[${i}].${key}`, value); 
                    } 
                    else {
                        // 파일의 리스트를 객체로 바꾸는 작업
                        const fileFormData = arrayFileVOToFormData(key, value)
                        for (const [fileKey, fileValue] of fileFormData.entries()) {
                            formData.append(`voList[${i}].${fileKey}`, fileValue); 
                        }
                    }
                }
                
            }
        }
    }
    catch(error)
    {
        console.error(error)
    }
   
    return formData;
}
/**
 * Array의 FileVO를 FormData로 변환 시 사용
 * @param {Object} voList  FileVO List,
 * @returns {FormData} FormData는 key는 fileList로 value는 FileVO 구성되어있다.
 */
export function arrayFileVOToFormData(key, voList) {
    let formData = new FormData()

    if(voList.length > 0)
    {
        for (const [i, element] of voList.entries()) {
            formData.append(`${key}[${i}].fileData`, element.file ?? new Blob([], { type: 'application/octet-stream' }));
            formData.append(`${key}[${i}].clntId`, element.clntId);
            formData.append(`${key}[${i}].writeDt`, element.writeDt);
            formData.append(`${key}[${i}].docNo`, element.docNo);
            formData.append(`${key}[${i}].filePath`, element.filePath);
            formData.append(`${key}[${i}].extension`, element.extension);
            formData.append(`${key}[${i}].fileSize`, element.fileSize);
            formData.append(`${key}[${i}].saveNm`, element.saveNm);
            if(element.targetType) {
                formData.append(`${key}[${i}].targetType`, element.targetType  );
            }
            formData.append(`${key}[${i}].useYn`, element.useYn);
            formData.append(`${key}[${i}].__created__`, element.__created__);
            formData.append(`${key}[${i}].__deleted__`, element.__deleted__ === undefined ? false : element.__deleted__);
        }
    }
 
    return formData;
}